import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { fetchApp } from '../../../store/apps/actions';
import withTranslation from '../../../hoc/withTranslation';
import Loading from '../../../components/common/Loading/Loading';
import styles from './QuizListPage.css';
import { Toolbar, ToolbarGroup } from 'material-ui/Toolbar';
import SearchBox from '../../../components/common/SearchBox/SearchBox';
import { search, setMapStyle, setOxMode } from '../../../store/ui/actions';
import { getQuizzes } from '../../../store/quizzes/actions';
import QuizList from '../../../components/quiz/QuizList/QuizList';
import { ADD_QUIZ_PAGE, QUIZ_PAGE, QUIZZES_PAGE } from '../../../constants/routes';
import {
    FloatingActionButton,
    IconButton,
    IconMenu,
    MenuItem,
    RefreshIndicator,
} from 'material-ui';
import Map from 'material-ui/svg-icons/maps/map';
import { Link } from 'react-router-dom';
import Settings from 'material-ui/svg-icons/action/settings';
import Mapbox, { MapStyle } from '../../../components/openexplore/Mapbox/Mapbox';
import List from 'material-ui/svg-icons/action/list';
import ContentAdd from 'material-ui/svg-icons/content/add';

export const DisplayMode = {
    MODE_LIST: 'mode_list',
    MODE_MAP: 'mode_map',
};

export class QuizListPage extends React.Component {
    static propTypes = {
        appPending: PropTypes.bool,
        app: PropTypes.object,
        match: PropTypes.object,
        currentLang: PropTypes.string,
        searchValue: PropTypes.string,
        t: PropTypes.func,
        search: PropTypes.func,
        getQuizzes: PropTypes.func,
        fetchApp: PropTypes.func,
        quizzes: PropTypes.object,
    };
    static defaultProps = {
        app: null,
    };

    state = {
        listMode: this.props.listMode,
        latlng: null,
    };

    componentWillMount() {
        this.fetchApplication();
        if (this.props.app && this.props.currentLang) {
            this.props.getQuizzes(this.props.app, this.props.currentLang);
        }
    }

    fetchApplication(appId = null) {
        if (this.props.match) {
            const id = appId || this.props.match.params.appId;
            if (id) {
                this.props.fetchApp(id);
            }
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.match !== nextProps.match) {
            this.fetchApplication(nextProps.match.params.appId);
        }
        if (
            this.props.app !== nextProps.app
            && nextProps.app
            && nextProps.currentLang
            && !this.props.quizzesPending
            && !nextProps.quizzesPending
        ) {
            this.props.getQuizzes(nextProps.app, nextProps.currentLang);
        }
    }

    onSearchChanged = (event, value) => {
        this.props.search(value);
    };

    toolbarContainerStyle() {
        let style = styles.toolBar.container;

        if (this.props.mode === DisplayMode.MODE_MAP) {
            style = {
                ...style,
                ...styles.toolBar.containerMap
            }
        } else {
            style = {
                ...style,
                ...styles.toolBar.containerList
            }
        }

        return style;
    }

    filteredQuizzes() {
        if (
            this.props.quizzes[this.props.currentLang] === undefined
            || this.props.quizzes[this.props.currentLang] === null
            || this.props.quizzes[this.props.currentLang].length === 0
        ) {
            return [];
        }
        const { searchValue } = this.props;
        if (!searchValue || searchValue.length === 0) {
            return this.props.quizzes[this.props.currentLang];
        }
        return this.props.quizzes[this.props.currentLang].filter((qu) => {
            return qu.name && qu.name.toLowerCase().includes(searchValue.toLowerCase());
        });
    }

    onQuizClicked = (quiz) => {
        this.props.history.push(
        QUIZ_PAGE
            .replace(':appId', this.props.app.id)
            .replace(':quizId', quiz.id)
        );
    };

    renderMap(quizzes) {
        return (
            <span>
                <Mapbox
                    mapStyle={this.props.mapStyle}
                    style={styles.map}
                    quizzes={quizzes}
                    onQuizClicked={this.onQuizClicked}
                    latlng={this.state.latlng}
                />
                <RefreshIndicator
                    size={50}
                    left={70}
                    top={0}
                    loadingColor="#FF9800"
                    status={this.props.quizzesPending
                        ? 'loading'
                        : 'hide'}
                    style={styles.loader}
                />
            </span>
        );
    }

    renderList(quizzes) {
        return (
            <div>
                <div style={styles.list.container}>
                    <QuizList
                        app={this.props.app}
                        quizzes={quizzes}
                        user={this.props.user}
                        title={this.props.t('module.quiz.quizzes')}
                    />
                </div>
            </div>
        );
    }

    onMapStyleChanged = (style) => {
        this.props.setMapStyle(style);
    };

    renderToolbar() {
        return (
            <Toolbar style={this.toolbarContainerStyle()}>
                <ToolbarGroup firstChild={true} style={styles.toolBar.searchBar}>
                    <SearchBox
                        onChange={this.onSearchChanged}
                        value={this.props.searchValue}
                    />
                </ToolbarGroup>
                {this.props.mode === DisplayMode.MODE_MAP &&
                    <Link to={QUIZZES_PAGE.replace(':appId', this.props.app.id)}>
                        <IconButton
                            onClick={() => this.props.setOxMode(DisplayMode.MODE_LIST)}
                            tooltip={this.props.t('module.quiz.list_mode')}
                            tooltipPosition="bottom-center"
                        >
                            <List />
                        </IconButton>
                    </Link>
                }
                {this.props.mode === DisplayMode.MODE_MAP && (
                    <IconMenu
                        iconButtonElement={
                            <IconButton
                                tooltip={this.props.t('module.open_explore.map_style_tooltip')}
                                tooltipPosition="bottom-center"
                            >
                                <Settings />
                            </IconButton>
                        }
                        targetOrigin={{
                            horizontal: 'right',
                            vertical: 'top',
                        }}
                        anchorOrigin={{
                            horizontal: 'right',
                            vertical: 'top',
                        }}
                    >
                        <MenuItem
                            primaryText={this.props.t('module.open_explore.map_style.streets')}
                            onClick={() => this.onMapStyleChanged(MapStyle.STREETS)}
                            checked={this.props.mapStyle === MapStyle.STREETS}
                        />
                        <MenuItem
                            primaryText={this.props.t('module.open_explore.map_style.satellite')}
                            onClick={() => this.onMapStyleChanged(MapStyle.SATELLITE)}
                            checked={this.props.mapStyle === MapStyle.SATELLITE}
                        />
                        <MenuItem
                            primaryText={this.props.t('module.open_explore.map_style.outdoors')}
                            onClick={() => this.onMapStyleChanged(MapStyle.OUTDOORS)}
                            checked={this.props.mapStyle === MapStyle.OUTDOORS}
                        />
                        <MenuItem
                            primaryText={this.props.t('module.open_explore.map_style.light')}
                            onClick={() => this.onMapStyleChanged(MapStyle.LIGHT)}
                            checked={this.props.mapStyle === MapStyle.LIGHT}
                        />
                        <MenuItem
                            primaryText={this.props.t('module.open_explore.map_style.dark')}
                            onClick={() => this.onMapStyleChanged(MapStyle.DARK)}
                            checked={this.props.mapStyle === MapStyle.DARK}
                        />
                    </IconMenu>
                )
                }
                {this.props.mode === DisplayMode.MODE_LIST && (
                    <IconButton
                        tooltip={this.props.t('module.quiz.map_mode')}
                        tooltipPosition="bottom-center"
                        onClick={() => this.props.setOxMode(DisplayMode.MODE_MAP)}
                    >
                        <Map />
                    </IconButton>
                )}
            </Toolbar>
        );
    }

    onAddQuizClicked = () => {
        let url = ADD_QUIZ_PAGE.replace(':appId', this.props.app.id);
        this.props.history.push(url);

    };
    renderFloatingButton() {
        return (
            <div>
                <FloatingActionButton
                    style={styles.floatingButton}
                    onClick={this.onAddQuizClicked}
                >
                    <ContentAdd />
                </FloatingActionButton>
            </div>
        );
    }
    render() {
        if (
            !this.props.app
            || (this.props.mode === DisplayMode.MODE_LIST && this.props.quizzesPending)
        ) {
            return <Loading paper={false} />
        }
        const quizzes = this.filteredQuizzes() || [];
        return (
            <div style={styles.container}>
                {
                    this.props.mode === DisplayMode.MODE_MAP
                    && this.renderMap(
                        quizzes.filter(q => q.latitude != null && q.longitude != null)
                    )
                }
                {this.props.mode === DisplayMode.MODE_LIST && this.renderList(quizzes)}
                {this.renderToolbar()}
                {this.renderFloatingButton()}
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    let props = {
        appPending: state.apps.pending,
        quizzesPending: state.quizzes.pending,
        quizzes: state.quizzes.content,
        currentLang: state.ui.currentLang,
        searchValue: state.ui.search,
        user: state.auth.content,
        mapStyle: state.ui.mapStyle,

    };
    if (state.apps.currentApplication) {
        props.app = state.apps.currentApplication;
    }
    if (!ownProps.mode) {
        props.mode = state.ui.oxMode;
    }
    return props;
}

export default connect(mapStateToProps, {
    fetchApp,
    search,
    getQuizzes,
    setOxMode,
    setMapStyle,
})(withRouter(withTranslation(QuizListPage)));



// WEBPACK FOOTER //
// src/containers/quiz/QuizListPage/QuizListPage.js